/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations_en from "./translations/en.json";
import translations_nl from "./translations/nl.json";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: "nl",
    lng: "nl",
    resources: {
      en: {
        common: translations_en,
      },
      nl: {
        common: translations_nl,
      },
    },
    supportedLngs: ["en", "nl"],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
